import client from "services/ngage/api-client";
import {QrCode, QrCodeData, QrCodeFormat} from "types/QrCode";
import DataPage from "types/DataPage";
import deserializeQrCode from "services/ngage/deserializers/qr-code";
import {queryString} from "services/string";

/**
 * Get all QR code (paginated)
 */
const all = async (page: number = 1, perPage: number = 100) => {
    const query = queryString({page, per_page: perPage})
    const response = await client.get<DataPage<QrCode> | null>(`/qr-codes?${query}`)

    if(response.data){
        response.data.data = response.data.data.map(deserializeQrCode)
    }

    return response.data
}

/**
 * Get a single QR code
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<QrCode>(`/qr-codes/${id}`)
    return deserializeQrCode(response.data)
}

/**
 * Get the download URL for a QR code asset
 */
const downloadUrl = (id: number, format: QrCodeFormat, size: number = 1000, subdomain: string | null = null) => {
    const params = {
        operator: subdomain,
        size: size ?? 1000
    };

    const paramString = Object
      .entries(params)
      .filter(([,value]) => value !== undefined && value !== null)
      .reduce((carry: string[], [key, value]) => [...carry, `${key}=${value}`], [])
      .join('&')

    return `${client.defaults.baseURL}/qr-codes/${id}/asset/${format}?${paramString}`
}

/**
 * Store a new QR code
 *
 * @param data
 */
const store = async (data: QrCodeData) => {
    const response = await client.post<QrCode>('/qr-codes', data)
    return deserializeQrCode(response.data)
}

/**
 * Update an existing QR code
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: QrCodeData) => {
    const response = await client.put<QrCode>(`/qr-codes/${id}`, data)
    return deserializeQrCode(response.data)
}

/**
 * Permanently delete a QR code
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/qr-codes/${id}`)
    return response.status === 204
}

const qrCodes = {
    all,
    get,
    downloadUrl,
    store,
    update,
    destroy
}

export default qrCodes;